// check create search complete
import { Action } from '@ngrx/store';
import { HotelFilterForm } from '@pages/travel/hotel/data-models';
import { HotelSearchPayload } from '@shared/models/hotel-search-payload.model';
import {
  HotelResult,
  HotelRoom,
  HotelRoomPriceOrdering,
  HotelSearchResponse,
} from '@shared/models/hotel-search-response.model';
import { IProductGroupOrdering, IRoomGroupOrder } from '@shared/shared/interfaces/site-settings.interfaces';
import { HotelSearchInitialState } from '../reducers/hotel-search.reducers';

export const CHECK_HOTEL_SEARCH_CANCEL = '[Travel Hotel Search] Cancel search';

// create search
export const CREATE_HOTEL_SEARCH = '[Travel Hotel Search] Create hotel search';

export const GET_HOTEL_SEARCH__RESULTS = '[Travel Hotel Search] Get hotel search results';
export const GET_HOTEL_SEARCH__RESULTS_SUCCESS = '[Travel Hotel Search] Get hotel search results success';
export const GET_HOTEL_SEARCH__RESULTS_FAILURE = '[Travel Hotel Search] Get hotel search results failure';

export const GET_HOTEL_RECOMMENDED__RESULTS = '[Travel Hotel Recommended] Get hotel recommended results';
export const GET_HOTEL_RECOMMENDED__RESULTS_SUCCESS =
  '[Travel Hotel Recommended] Get hotel recommended results success';
export const GET_HOTEL_RECOMMENDED__RESULTS_FAILURE =
  '[Travel Hotel Recommended] Get hotel recommended results failure';

export const CLEAR_HOTEL_SEARCH = '[Travel Hotel Search] Clear hotel search';
export const CLEAR_SELECTED_HOTEL = '[Travel Hotel Search] Clear selected hotel';

export const FILTER_HOTEL_SEARCH_RESULTS = '[Travel Hotel Search] Filter hotel search results new';
export const FILTER_HOTELS = '[Travel Hotel Search] Filter hotels';
export const UPDATE_FILTER_FORM = '[Travel Hotel Search] Change filter form';
export const UPDATE_DEFAULT_HOTEL_FILTER_FORM = '[Travel Hotel Search] Update default hotel filter form';
export const CLEAR_FILTER_FORM = '[Travel Hotel Search] Clear filter form';

export const SELECT_HOTEL_RESULT = '[Travel Hotel Search] Select a hotel result';
export const SELECT_HOTEL_RESULT_SUCCESS = '[Travel Hotel Search] Select a hotel result success';
export const SELECT_HOTEL_ROOM = '[Travel Hotel Search] Select a hotel room';

export const SORT_HOTEL_ROOMS = '[Travel Hotel Search] Sort hotel rooms';

export const RESTORE_HOTELS = '[Travel Hotel Search] Restore hotels';
export const RESTORE_HOTELS_SUCCESS = '[Travel Hotel Search] Restore hotels success';

export const CHANGE_HOTEL_PREFERENCE = '[Travel Hotel Search] Toggle hotel preference';
export const CHANGE_HOTEL_SEARCH_BY_NAME = '[Travel Hotel Search] Change hotel search by name';
export const SELECT_HOTEL_SEARCH_BY_NAME = '[Travel Hotel Search] Select hotel search by name';

export class ClearHotelSearch implements Action {
  readonly type = CLEAR_HOTEL_SEARCH;
  constructor(public data: { clearSelectedHotel: boolean }) {}
}

export class ClearSelectedHotel implements Action {
  readonly type = CLEAR_SELECTED_HOTEL;
}

export class ChangeHotelPreference implements Action {
  readonly type = CHANGE_HOTEL_PREFERENCE;
  constructor(
    public id: number,
    public preferred: boolean
  ) {}
}

export class CreateHotelSearch implements Action {
  readonly type = CREATE_HOTEL_SEARCH;
  constructor(public payload: HotelSearchPayload) {}
}

export class GetHotelSearchResults implements Action {
  readonly type = GET_HOTEL_SEARCH__RESULTS;
  constructor(public payload: HotelSearchPayload) {}
}

export class GetHotelSearchResultsSuccess implements Action {
  readonly type = GET_HOTEL_SEARCH__RESULTS_SUCCESS;
  constructor(public payload: HotelSearchResponse) {}
}

export class GetHotelSearchResultsFailure implements Action {
  readonly type = GET_HOTEL_SEARCH__RESULTS_FAILURE;
  constructor(public payload: any) {}
}

export class GetHotelRecomendedResults implements Action {
  readonly type = GET_HOTEL_RECOMMENDED__RESULTS;
  constructor(public payload: any) {}
}

export class GetHotelRecomendedResultsSuccess implements Action {
  readonly type = GET_HOTEL_RECOMMENDED__RESULTS_SUCCESS;
  constructor(public payload: any) {}
}

export class GetHotelRecomendedResultsFailure implements Action {
  readonly type = GET_HOTEL_RECOMMENDED__RESULTS_FAILURE;
  constructor(public payload: any) {}
}

export class CancelHotelSearch implements Action {
  readonly type = CHECK_HOTEL_SEARCH_CANCEL;
}

export class FilterHotelSearchResults implements Action {
  readonly type = FILTER_HOTEL_SEARCH_RESULTS;
  constructor(public payload: any) {}
}

export class SelectHotelSearchByName implements Action {
  readonly type = SELECT_HOTEL_SEARCH_BY_NAME;
  constructor() {}
}

export class SelectHotelResult implements Action {
  readonly type = SELECT_HOTEL_RESULT;
  constructor(public payload: number) {}
}

export class SelectHotelResultSuccess implements Action {
  readonly type = SELECT_HOTEL_RESULT_SUCCESS;
  constructor(
    public payload: {
      hotelId: number;
      productGroupsForBanner: IProductGroupOrdering[];
      productGroups: IRoomGroupOrder[];
      isPricePerRoomPerNight: boolean;
      isProductGroupOrdering: boolean;
      defaultPriceOrder: HotelRoomPriceOrdering;
    }
  ) {}
}

export class SelectHotelRoom implements Action {
  readonly type = SELECT_HOTEL_ROOM;
  constructor(public payload: HotelRoom[]) {}
}

export class ChangeHotelSearchByName implements Action {
  readonly type = CHANGE_HOTEL_SEARCH_BY_NAME;
  constructor(
    public hotelName: string,
    public hotelIsSelected: boolean
  ) {}
}

export class RestoreHotels implements Action {
  readonly type = RESTORE_HOTELS;
}

export class RestoreHotelsSuccess implements Action {
  readonly type = RESTORE_HOTELS_SUCCESS;
  constructor(
    public payload: {
      hotelSearch: HotelSearchPayload;
      hotelSearchResults: HotelSearchInitialState['hotelSearchResults'];
      selectedHotel: HotelResult;
      selectedRoom: HotelRoom;
    }
  ) {}
}

export class FilterHotels implements Action {
  readonly type = FILTER_HOTELS;
  constructor(public payload: any) {}
}

export class UpdateFilterForm implements Action {
  readonly type = UPDATE_FILTER_FORM;
  constructor(public payload: HotelFilterForm) {}
}

export class UpdateDefaultHotelFilterForm implements Action {
  readonly type = UPDATE_DEFAULT_HOTEL_FILTER_FORM;
  constructor(public payload: HotelFilterForm) {}
}

export class ClearFilterForm implements Action {
  readonly type = CLEAR_FILTER_FORM;
}

export type HotelSearchActions =
  | ClearHotelSearch
  | ClearSelectedHotel
  | ChangeHotelPreference
  | ChangeHotelSearchByName
  | CreateHotelSearch
  | GetHotelSearchResults
  | GetHotelSearchResultsSuccess
  | GetHotelSearchResultsFailure
  | GetHotelRecomendedResults
  | GetHotelRecomendedResultsSuccess
  | GetHotelRecomendedResultsFailure
  | CancelHotelSearch
  | ClearFilterForm
  | FilterHotelSearchResults
  | FilterHotels
  | UpdateFilterForm
  | UpdateDefaultHotelFilterForm
  | SelectHotelSearchByName
  | SelectHotelResult
  | SelectHotelResultSuccess
  | SelectHotelRoom
  | RestoreHotels
  | RestoreHotelsSuccess;
